import config from 'config';

const tldToBuilderLocales = config.get('public.intl.builderLocales') || {};
const locales = Object.values(tldToBuilderLocales);

export { tldToBuilderLocales, locales };
